import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { MechanicValidatorRoad } from '@colonist/game-mechanic-validators';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { useCurrentStateValidator } from './useCurrentStateValidator.ts';
import { useMapValidator } from './useMapValidator.ts';
export const useMechanicValidatorRoad = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const currentStateValidator = useCurrentStateValidator();
    const mechanicRoadState = useGameStore((state)=>state.gameState.mechanicRoadState);
    return useMemo(()=>{
        if (!mechanicRoadState) return undefined;
        return new MechanicValidatorRoad(playerValidators, mapValidator, currentStateValidator, mechanicRoadState);
    }, [
        playerValidators,
        mapValidator,
        currentStateValidator,
        mechanicRoadState
    ]);
};
